var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_c('van-area',{attrs:{"area-list":_vm.areaList},on:{"confirm":_vm.onConfirm,"cancel":_vm.onCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }